module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/postcode.js
// module id = 705
// module chunks = 0